<div class="period-filter" (click)="selectModalPeriod()">
  <p class="period-filter__label">Período:</p>
  <p class="period-filter__area" *ngIf="startDate">
    <i class="material-icons">date_range</i>
    <span i18n>De {{ startDate | moment: 'L' }} à {{ endDate | moment: 'L' }}</span>
  </p>
</div>
